const Config = {
    domain: "https://clan.tno.cz",
    private: "https://www.roblox.com/share?code=7e73a31ba3c0c248a2a2b6eae06a3b41&type=Server"
  };
  
  export default Config;
